const prefix = 'dashboard-page';

export const i18n = {
    title: {
        id: `${prefix}.title`,
        defaultMessage: 'Dashboard',
    },
} as const;
